import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Action } from '@app/pathway-frontend';
import { ModuleFE_EHRInstallation } from '../../../../../_entity/installation/index.js';
const escapeCSVField = (field) => {
    if (field.includes(',') || field.includes('"') || field.includes('\n'))
        return `"${field.replace(/"/g, '""')}"`;
    return field;
};
export const exportOrderMappingAsCSV = (props) => {
    const { installationId, installationOrders } = props;
    const installation = ModuleFE_EHRInstallation.cache.unique(installationId);
    if (!installation)
        throw new MUSTNeverHappenException(`cannot resolve ehr installation with id ${installationId}`);
    // CSV Headers
    const headers = ['Quai Order Name', 'Quai Order Id', 'Installation Order Id'];
    // CSV Rows
    const rows = installationOrders.map(installationOrder => {
        const dbOrder = ModuleFE_Action.cache.unique(installationOrder.orderId);
        if (!dbOrder)
            throw new MUSTNeverHappenException(`cannot find db order with id ${installationOrder.orderId}`);
        return [
            escapeCSVField(dbOrder.name),
            escapeCSVField(installationOrder.orderId),
            escapeCSVField(installationOrder.ehrInstallationOrderId ?? '-')
        ];
    });
    // Build CSV content
    const csvContent = [
        headers.join(','),
        ...rows.map(row => row.join(','))
    ].join('\n');
    // Create and download the file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${installation.label}_order_mapping.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
//# sourceMappingURL=ExportOrderMappingCSV.js.map